export const trackDeleteCardSuccess = () => {
    return {
        event: 'delete card',
        effect: 'delete card',
        category: {
            subCategory: 'saved cards',
        },
    }
}
